import { AxiosError } from 'axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { useTransmissionStore } from '@editorStores'
import { useResultsInvalidation } from '@editorHooks'
import { getStiffeningIntervals, getTensileTransmissionGraph } from '@queries'
import { saveTensileTransmissionGraph } from '@mutations'
import { buildErrorMessage } from 'src/constants/errors'

export const useSaveTensileTransmissionGraph = (projectId: string) => {
  const { enqueueSnackbar } = useSnackbar()
  const queryClient = useQueryClient()
  const invalidateResults = useResultsInvalidation()
  const setTensileTransmissionGraph = useTransmissionStore(
    state => state.setTensileTransmissionGraph,
  )

  return useMutation(
    (data: TensileTransmissionGraph) => saveTensileTransmissionGraph.request(projectId, data),
    {
      onSuccess: async data => {
        // The tensile transmitter form keeps unsaved edits to itself, they reach the store here
        setTensileTransmissionGraph(data)
        queryClient.setQueryData(getTensileTransmissionGraph.getKey(projectId), data)
        await queryClient.invalidateQueries(getStiffeningIntervals.getKey(projectId))
        invalidateResults(projectId)
        enqueueSnackbar('Kraftübertragung erfolgreich gespeichert', { variant: 'success' })
      },
      // The store still holds the saved graph, so there is nothing to roll back. Refetching would
      // reinitialize the form and drop the edits the user wants to fix or discard
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Speichern der Kraftübertragung'), {
          variant: 'error',
        })
      },
    },
  )
}
